import http from "./httpService";
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/users/register";

export function register(user) {
  return http.post(apiEndpoint, {
    name: user.name,
    dateOfBirth: user.dateOfBirth,
    email: user.email,
    password: user.password,
  });
}
